import { MasonryPage } from 'components/masonry-page/masonry-page.component';
import { MASONRY } from 'common/constants';

export const SupportPage = () => (
  <MasonryPage
    screenName="Support"
    titleMessageId="STR_SUPPORT"
    rootNodeId={MASONRY.ROOT_NODE_ID_SUPPORT_PAGE}
  />
);
